import { render, staticRenderFns } from "./InTkEdit.vue?vue&type=template&id=a8893c42&scoped=true&"
import script from "./InTkEdit.vue?vue&type=script&lang=js&"
export * from "./InTkEdit.vue?vue&type=script&lang=js&"
import style0 from "./InTkEdit.vue?vue&type=style&index=0&id=a8893c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8893c42",
  null
  
)

export default component.exports